module.exports = __webpack_public_path__ + "img/input_on.a3245bc2.svg";